module.exports = __webpack_public_path__ + "img/47.04391397.jpg";